import { ChangeDetectionStrategy, ChangeDetectorRef, Component, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SliceClass } from 'interfaces';
import { MetaService } from 'utils';
import { SlicesComponent } from '../components/slices/slices.component';

@Component({
  selector: 'app-landing-page',
  templateUrl: './landing-page.component.html',
  standalone: true,
  imports: [SlicesComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LandingPageComponent {
  private route = inject(ActivatedRoute);
  private meta = inject(MetaService);
  private cdr = inject(ChangeDetectorRef);
  slices: SliceClass[];

  constructor() {
    this.route.data.subscribe(data => {
      this.slices = data.cmsData.slices;
      this.meta.setTitle(data.cmsData.title);
      this.meta.setDescription(data.cmsData.metaDescription);
      this.meta.setRobotsNoIndex(data.cmsData.metaRobotsNoIndex);
      this.cdr.markForCheck();
    });
  }
}
